<template>
  <div>
    <v-layout wrap class="py-3">
      <v-flex xs8>
        <multiselect
          id="ajax"
          v-model="filterBeacon"
          class="mb-2"
          :options="beaconBranchOptions"
          :show-no-results="true"
          :placeholder="$t('Beacon')"
          label="name"
          track-by="beacon_id"
          @input="handleFetchAllData"
        >
        </multiselect>
      </v-flex>
      <v-flex xs4 class="text-sm-right text-xs-right">
        <v-btn outline color="primary" @click="handleExportXlsx">
          <em class="fas fa-file-export" />&nbsp;{{ $t('export') }}
        </v-btn>
      </v-flex>
    </v-layout>
    <template v-if="isSpecificBeaconPage">
      <div class="py-3">
        <MetricUserGroupsByDateChart
          v-model="userGroupsBydateData"
          @exportData="handleSetExportData('user-group', $event)"
        />
      </div>
      <div class="py-3">
        <MetricMessagesGroupByTimeChart
          v-model="messagesGroupByTimeData"
          @exportData="handleSetExportData('message-group', $event)"
        />
      </div>
    </template>
    <div class="py-3">
      <MetricUsersByDateChart v-model="usersByDateData" />
    </div>
    <div class="py-3">
      <MetricMessagesByTimeChart v-model="messagesbyTime" />
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { mapGetters } from 'vuex'
import Multiselect from 'vue-multiselect'
import * as XLSX from 'xlsx'
import MetricUserGroupsByDateChart from './Charts/MetricUserGroupsByDateChart.vue'
import MetricMessagesGroupByTimeChart from './Charts/MetricMessagesGroupByTimeChart.vue'
import MetricUsersByDateChart from './Charts/MetricUsersByDateChart.vue'
import MetricMessagesByTimeChart from './Charts/MetricMessagesByTimeChart.vue'
import beaconApi from '@/api/beacon'
import { handleResponse, handleApiError } from '@/api/util'
import cloneDeep from 'lodash/cloneDeep'

export default {
  components: {
    Multiselect,
    MetricUserGroupsByDateChart,
    MetricMessagesGroupByTimeChart,
    MetricUsersByDateChart,
    MetricMessagesByTimeChart
  },
  props: ['selectedDate'],
  data() {
    return {
      filterBeacon: null,
      currentSelectedDate: '',
      userGroupsBydateData: null,
      messagesGroupByTimeData: null,
      usersByDateData: null,
      messagesbyTime: null,
      exportDataUserGroupsByDate: null,
      exportMessagesGroupByTime: null,
      exportDataUsersByDate: null,
      exportDataMessagesbyTime: null
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    beaconBranchOptions() {
      let options = []
      const tempData = this.$store.state.beaconMasterData.beaconBranch

      if (tempData) {
        options = tempData.map((el) => {
          return { beacon_id: el.beacon_id, name: el.name }
        })
      }

      return options
    },
    getTimeList() {
      return [
        '00:00',
        '01:00',
        '02:00',
        '03:00',
        '04:00',
        '05:00',
        '06:00',
        '07:00',
        '08:00',
        '09:00',
        '10:00',
        '11:00',
        '12:00',
        '13:00',
        '14:00',
        '15:00',
        '16:00',
        '17:00',
        '18:00',
        '19:00',
        '20:00',
        '21:00',
        '22:00',
        '23:00'
      ]
    },
    isSpecificBeaconPage() {
      return this.$store.state.beaconPageIdList.includes(this.selectedBot.pageid)
    }
  },
  watch: {
    selectedDate: function () {
      this.currentSelectedDate = this.selectedDate
      this.handleFetchAllData()
    }
  },
  mounted() {
    if (this.selectedDate) {
      this.currentSelectedDate = this.selectedDate
      this.handleFetchAllData()
    }
  },
  methods: {
    async handleFetchAllData() {
      const vm = this
      try {
        const config = {
          pageid: vm.selectedBot.pageid,
          data: {
            dateFrom: dayjs(vm.currentSelectedDate.start).format('YYYY-MM-DD'),
            dateTo: dayjs(vm.currentSelectedDate.end).format('YYYY-MM-DD')
          }
        }

        if (vm.filterBeacon) {
          Object.assign(config.data, { beaconId: vm.filterBeacon.beacon_id })
        }
        vm.$store.dispatch('loading')
        await vm.getAnalyticsMetricUsersGroupAudienceByDate(config)
        await vm.getAnalyticsMetricMessagesGroupAudienceByTime(config)
        await vm.getAnalyticsMetricUsersByDate(config)
        await vm.getAnalyticsMetricMessagesByTime(config)
        vm.$store.commit('CLEAR_LOADING')
      } catch (error) {
        console.error(error)
        vm.$store.commit('CLEAR_LOADING')
      }
    },
    async getAnalyticsMetricUsersGroupAudienceByDate(payload) {
      const vm = this
      try {
        const response = await beaconApi.getAnalyticsMetricUsersGroupAudienceByDate({
          config: payload
        })

        handleResponse(response)

        if (response && response.status === 200 && response.data) {
          vm.userGroupsBydateData = response.data.data
        }
      } catch (error) {
        vm.$store.commit('CLEAR_LOADING')
        handleApiError(error)
      }
    },
    async getAnalyticsMetricMessagesGroupAudienceByTime(payload) {
      const vm = this
      try {
        const response = await beaconApi.getAnalyticsMetricMessagesGroupAudienceByTime({
          config: payload
        })

        handleResponse(response)

        if (response && response.status === 200 && response.data) {
          vm.messagesGroupByTimeData = response.data.data
        }
      } catch (error) {
        vm.$store.commit('CLEAR_LOADING')
        handleApiError(error)
      }
    },
    async getAnalyticsMetricUsersByDate(payload) {
      const vm = this
      try {
        const response = await beaconApi.getAnalyticsMetricUsersByDate({ config: payload })

        handleResponse(response)

        if (response && response.status === 200 && response.data) {
          vm.usersByDateData = response.data.data
        }
      } catch (error) {
        vm.$store.commit('CLEAR_LOADING')
        handleApiError(error)
      }
    },
    async getAnalyticsMetricMessagesByTime(payload) {
      const vm = this
      try {
        const response = await beaconApi.getAnalyticsMetricMessagesByTime({ config: payload })

        handleResponse(response)

        if (response && response.status === 200 && response.data) {
          vm.messagesbyTime = response.data.data
        }
      } catch (error) {
        vm.$store.commit('CLEAR_LOADING')
        handleApiError(error)
      }
    },
    transformExportData() {
      let dataSheet1 = []
      if (this.isSpecificBeaconPage) {
        dataSheet1.push([
          `${this.$t('from')} ` +
            dayjs().format('DD/MM/YYYY') +
            ` ${this.$t('to')} ` +
            dayjs().format('DD/MM/YYYY')
        ])
        dataSheet1.push([])
        dataSheet1.push(['ผู้ใช้ตามวันที่ระบุ'])

        const dataSheet1Data = this.exportDataUserGroupsByDate
        const dataSheet1DataItems = cloneDeep(dataSheet1Data.data)

        dataSheet1.push(dataSheet1Data.header)
        dataSheet1DataItems.forEach((item) => {
          dataSheet1.push(item)
        })
      }

      let dataSheet2 = []
      if (this.isSpecificBeaconPage) {
        dataSheet2.push([
          `${this.$t('from')} ` +
            dayjs().format('DD/MM/YYYY') +
            ` ${this.$t('to')} ` +
            dayjs().format('DD/MM/YYYY')
        ])
        dataSheet2.push([])
        dataSheet2.push(['ข้อความตามเวลาระบุ'])

        const dataSheet2Data = this.exportMessagesGroupByTime
        const dataSheet2DataItems = cloneDeep(dataSheet2Data.data)

        dataSheet2.push(dataSheet2Data.header)
        dataSheet2DataItems.forEach((item) => {
          dataSheet2.push(item)
        })
      }

      let dataSheet3 = []
      dataSheet3.push([
        `${this.$t('from')} ` +
          dayjs().format('DD/MM/YYYY') +
          ` ${this.$t('to')} ` +
          dayjs().format('DD/MM/YYYY')
      ])
      dataSheet3.push([])
      dataSheet3.push(['ผู้ใช้ตามประเภทการส่ง'])
      dataSheet3.push(['วันที่', 'ผู้ใช้ตามเวลาที่ระบุ', 'Friend', 'Non-Friend'])

      const dataSheet3DataItems = cloneDeep(this.usersByDateData)
      Object.keys(dataSheet3DataItems).forEach((key) => {
        const tempVal = dataSheet3DataItems[key]
        dataSheet3.push([key, tempVal.total_users, tempVal.friend, tempVal.non_friend])
      })

      let dataSheet4 = []
      dataSheet4.push([
        `${this.$t('from')} ` +
          dayjs().format('DD/MM/YYYY') +
          ` ${this.$t('to')} ` +
          dayjs().format('DD/MM/YYYY')
      ])
      dataSheet4.push([])
      dataSheet4.push(['ข้อความตามเวลาที่ระบุ'])
      dataSheet4.push(['เวลา', 'ข้อความตามเวลาที่ระบุ', 'Friend', 'Non-Friend'])

      const tempGetTimeList = this.getTimeList
      const dataSheet4DataItems = cloneDeep(this.messagesbyTime)

      Object.keys(dataSheet4DataItems).forEach((key, index) => {
        const tempVal = dataSheet4DataItems[key]
        dataSheet4.push([
          tempGetTimeList[index],
          tempVal.total_messages,
          tempVal.friend,
          tempVal.non_friend
        ])
      })

      return { dataSheet1, dataSheet2, dataSheet3, dataSheet4 }
    },
    handleExportXlsx() {
      const vm = this
      try {
        vm.$store.dispatch('loading')

        const { dataSheet1, dataSheet2, dataSheet3, dataSheet4 } = vm.transformExportData()

        const wb = XLSX.utils.book_new()
        const dataWS1 = XLSX.utils.json_to_sheet(dataSheet1)
        const dataWS2 = XLSX.utils.json_to_sheet(dataSheet2)
        const dataWS3 = XLSX.utils.json_to_sheet(dataSheet3)
        const dataWS4 = XLSX.utils.json_to_sheet(dataSheet4)

        const header = [['', '', '', '']]
        if (this.isSpecificBeaconPage) {
          XLSX.utils.sheet_add_aoa(dataWS1, header)
          XLSX.utils.sheet_to_json(dataWS1, { origin: 'A2', skipHeader: true })
          XLSX.utils.book_append_sheet(wb, dataWS1, 'จำนวนผู้ใช้ตามกลุ่มเป้าหมาย')

          XLSX.utils.sheet_add_aoa(dataWS2, header)
          XLSX.utils.sheet_to_json(dataWS2, { origin: 'A2', skipHeader: true })
          XLSX.utils.book_append_sheet(wb, dataWS2, 'จำนวนข้อความส่งตามกลุ่มเป้าหมาย')
        }

        XLSX.utils.sheet_add_aoa(dataWS3, header)
        XLSX.utils.sheet_to_json(dataWS3, { origin: 'A2', skipHeader: true })
        XLSX.utils.book_append_sheet(wb, dataWS3, 'จำนวนผู้ใช้ตามประเภทการส่ง')

        XLSX.utils.sheet_add_aoa(dataWS4, header)
        XLSX.utils.sheet_to_json(dataWS4, { origin: 'A2', skipHeader: true })
        XLSX.utils.book_append_sheet(wb, dataWS4, 'จำนวนข้อความตามประเภทการส่ง')
        XLSX.writeFile(wb, `beacon-metric.xlsx`)

        vm.$store.commit('CLEAR_LOADING')
      } catch (error) {
        vm.$store.commit('CLEAR_LOADING')
        console.error(error)
      }
    },
    handleSetExportData(type, data) {
      if (type === 'user-group') {
        this.exportDataUserGroupsByDate = data
      } else if (type === 'message-group') {
        this.exportMessagesGroupByTime = data
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/Beacon/Analytics/Metric.vue